import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=08088a92&scoped=true&"
import script from "./baseForm.vue?vue&type=script&lang=js&"
export * from "./baseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08088a92",
  null
  
)

export default component.exports